<template>
  <div id="page-slider" ref="slides">
    <component
      v-for="index in 5"
      :key="index"
      :is="`PageSlide${index}`"
      :show="index == activeSlide"
    />
  </div>
</template>

<script>
import PageSlide1 from "./PageSlide1";
import PageSlide2 from "./PageSlide2";
import PageSlide3 from "./PageSlide3";
import PageSlide4 from "./PageSlide4";
import PageSlide5 from "./PageSlide5";
import { scrollY } from "@/assets/js/utils"
import tabs from "@/data/tabs"

export default {
  name: "PageSlider",
  components: { PageSlide1, PageSlide2, PageSlide3, PageSlide4, PageSlide5 },
  data: function() {
    return {
      activeSlide: 0,
      slidePoint: 0.85,
      url: tabs.map(tabs => tabs.to)
    };
  },
  methods: {
    handleScroll() {
      let slideHeight = this.$refs.slides.childNodes[0].clientHeight;
      let slidePoint = !this.activeSlide ? 0.5 : this.slidePoint;
      let scrollPosition = scrollY()
      if (
        !this.activeSlide ||
        scrollPosition >= slideHeight * (this.activeSlide - 1 + slidePoint) ||
        scrollPosition <= slideHeight * (this.activeSlide - 1 - slidePoint)
      ) {
        let scrollY = scrollPosition + slideHeight * (1 - slidePoint);
        this.activeSlide = Math.floor(scrollY / slideHeight) + 1;
        let url = this.url[this.activeSlide - 1];
        if (this.$route.fullPath !== url) this.$router.replace(url);
      }
    }
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted: function() {
    setTimeout(this.handleScroll, 1);
  }
};
</script>

<style lang="scss" scoped>
#page-slider {
  width: 100%;
  height: 100%;
  .page-slide {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: $page-slide-min-height;
    padding-bottom: $page-slide-padding-bottom;
    overflow: hidden;
    object-fit: fill;
  }
}
</style>
